import { useInfiniteQuery } from 'react-query';
import {
  getAdaptedFictionEditionReplies,
  type GetAdaptedFictionEditionRepliesParams
} from '../../services/commentsAndLikeService';
import { SCENE_QUERY_KEYS } from '../queryKeys';

export function useGetAdaptedFictionEditionReplies({
  adaptedFictionEditionId,
  commentId,
  params
}: {
  adaptedFictionEditionId: string;
  commentId: string;
  params: GetAdaptedFictionEditionRepliesParams;
}) {
  const perPage = params?.per_page ?? 20;

  return useInfiniteQuery({
    queryKey: [
      ...SCENE_QUERY_KEYS.adaptedFictionEditionReplies(adaptedFictionEditionId, commentId),
      perPage
    ],
    queryFn: ({ pageParam = 1 }) =>
      getAdaptedFictionEditionReplies({
        adaptedFictionEditionId,
        commentId,
        params: {
          ...params,
          page: pageParam,
          per_page: perPage
        }
      }),
    getNextPageParam: (lastPage) => {
      const pagination = lastPage?.meta?.pagination;
      if (!pagination) return undefined;
      if (pagination.currentPage >= pagination.totalPages) return undefined;
      return pagination.currentPage + 1;
    },
    enabled: !!adaptedFictionEditionId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5
  });
}
